export const DirectDataInputConstant = {
    CATEGORY: "Counter Charge",
    TITLE: "Direct Data Input Details",
    SEARCH_CRITERIA: "Search Criteria",
    MASTER_TYPE: "Master Type",
    OPS_DATE_FROM: 'Ops Date(From)',
    OPS_DATE_TO: 'Ops Date(To)',
    OPS_DATE: 'Ops Date',
    OPS_DATE_RANGE: 'Ops Date Range',
    FORWARDER_CODE: 'Forwarder Code',
    FORWARDER_SHIPPER_CONSIGNEE: 'Forwarder/Shipper/Consignee',
    TRUCKER_NAME: 'Trucker Name',
    CNIC_NO: 'CNIC No',
    VEHICLE_NO: 'Vehicle No',
    DAMAGE_TYPE: 'Damage Type',
    NATURE: 'Nature',
    REMARK: 'Remark',
    AMOUNT: 'Amount',
    STATUS: 'Status',
    OPERATING_TML: 'Operating Tml',
}
